import { type ReactNode } from "react";
import classNames from "classnames";
import drawerStyles from "../ScheduleDrawer.module.scss";

/** A full-screen card row: the label on the left, its control beside it. */
export const DrawerInlineRow = ({
    label,
    labelId,
    children,
}: {
    label: string;
    labelId?: string;
    children: ReactNode;
}) => (
    <div
        className={classNames(drawerStyles.cardRow, drawerStyles.cardRowFlush)}
    >
        <span id={labelId} className={drawerStyles.inlineLabel}>
            {label}
        </span>
        {children}
    </div>
);
